<app-header [headerText]="employeeInfo"></app-header>
<div class="row justify-content-end mx-3">
    <button  mat-fab color="primary" aria-label="detalle"  [routerLink]="['./../detail']"> <mat-icon>keyboard_arrow_right</mat-icon></button>
</div>

<div class="row" *ngIf="currentEmployee && data.length > 0 ; else nullData">

        <div class="col-md-6 mt-2"  style="font-size: 80%; padding-right: 0px;">
            <div class="row px-3" >
                <div style="text-align: center">
                    <b> "Los valores de aportaciones y rendimientos mostrados en caja de ahorro permanente son netos, después de disminuir retiros realizados"</b>
                </div>
                <br>
            </div>
            <div class="row px-3 border-bottom">
                <div
                    class="col-md-3 border-right d-flex align-items-center justify-content-center bg-report-header text-white">
                    Tipo de Ahorro
                </div>
    
                <div class="col-md-3 d-flex border-right justify-content-center bg-report-header text-white">Aportación
                </div>
                <div class="col-md-3 d-flex border-right justify-content-center bg-report-header text-white">Rendimiento</div>
                <div class="col-md-3 d-flex border-right justify-content-center bg-report-header text-white">Total Ahorro
                </div>
            </div>
            <div *ngFor="let item of data">
                <div class="row px-3" *ngIf="item.name">
                    <div class="col-md-3 d-flex border-left border-bottom border-right justify-content-center" st>{{item.name}}
                    </div>
                    <div class="col-md-3 d-flex border-left border-bottom border-right justify-content-center">
                        {{item.aportacion  ? '$ ' + (item.aportacion | number: '.2-2') : '-'}}</div>
                    <div class="col-md-3 d-flex border-left border-bottom border-right justify-content-center">{{item.rendimiento
                        ? '$ ' + (item.rendimiento | number: '.2-2') : '-'}}</div>
                    <div class="col-md-3 d-flex border-left border-bottom border-right justify-content-center">{{item.amount
                        ? '$ ' + (item.amount | number: '.2-2') : '-'}}</div>
    
                </div>
            </div>
            
            <div class="row px-3" *ngIf="data.length > 0 && totalAcumulado > 0 ">
                <div class="col-md-3 d-flex border-right justify-content-center bg-report-gray"><b>Gran Total</b>
                </div>
                <div class="col-md-3 d-flex border-right justify-content-center bg-report-gray">
                   <b> {{totalAportacion ? '$ ' + (totalAportacion | number: '.2-2') : '0'}}</b></div>
                <div class="col-md-3 d-flex border-right justify-content-center bg-report-gray"><b>{{totalRendimiento
                    ? '$ ' + (totalRendimiento | number: '.2-2') : '0'}}</b></div>
                <div class="col-md-3 d-flex border-right justify-content-center bg-report-gray"><b>{{totalAcumulado
                    ? '$ ' + (totalAcumulado | number: '.2-2') : '0'}}</b></div>
            </div>            
            <br>
            <div class="row px-3">
                <div class="col-md-12 d-flex border-right justify-content-center">
                    <b> "Aportación y Rendimiento, considera el total hasta el día hábil anterior"</b>
                </div>
            </div>
            <br>
    
            <div class="row mt-5 mb-5" *ngIf="currentEmployee">
                <div class="col-md-12">
                    <div class="row mx-5 border-bottom" *ngIf="dataLoanPermanent && dataLoanPermanent.length > 0">
                        <div
                            class="col-md-12 border-right d-flex align-items-center justify-content-center bg-report-header text-white">
                            Préstamo Caja Permanente
                        </div>
                    </div>
                    <div *ngFor="let item of dataLoanPermanent">
            
                        <div class="row mx-5">
                            <div class="col-md-6 d-flex border-left border-bottom border-right justify-content-center">{{item.name}}
                            </div>
                            <div class="col-md-6 d-flex border-left border-bottom border-right justify-content-center" *ngIf="item.position != 3">
                                {{item.amount ? '$ ' + (item.amount | number: '.2-2') : '-'}}</div>
                                <div class="col-md-6 d-flex border-left border-bottom border-right justify-content-center" *ngIf="item.position === 3">
                                {{item.pending +  ' / ' + item.amount}}</div>
                        </div>
            
                    </div>
                    <div class="row mx-5 ">
                        <div
                        class="col-md-12 d-flex  justify-content-center">
                            &nbsp;
                        </div>
                    </div>
            
                    <div class="row mx-5 border-bottom mt-1" *ngIf="dataLoanRetirement && dataLoanRetirement.length > 0">
                        <div
                            class="col-md-12 border-right d-flex align-items-center justify-content-center bg-report-header text-white">
                            Préstamo Caja Retiro
                        </div>
                    </div>
                    <div *ngFor="let item of dataLoanRetirement">
            
                        <div class="row mx-5">
                            <div class="col-md-6 d-flex border-left border-bottom border-right justify-content-center">{{item.name}}
                            </div>
                            <div class="col-md-6 d-flex border-left border-bottom border-right justify-content-center" *ngIf="item.position != 3">
                                {{item.amount ? '$ ' + (item.amount | number: '.2-2') : '-'}}</div>
                                <div class="col-md-6 d-flex border-left border-bottom border-right justify-content-center" *ngIf="item.position === 3">
                                {{item.pending +  ' / ' + item.amount}}</div>
                        </div>
            
                    </div>  
                </div>
            </div>
        </div>
        <div class="col-md-6 mt-4 align-items-center justify-content-center" style="padding: 0px;" >
    
            <h4 *ngIf = "data.length > 0" style="text-align: center">Portafolio Consolidado</h4>
            <div class="chart-wrapper mt-2" *ngIf="data && pieChartData2.length > 0">
                <canvas baseChart
                [data]="pieChartData2"
                [labels]="pieChartLabels"
                [chartType]="pieChartType"
                [options]="pieChartOptions"></canvas>
            </div>
            <br>
            <div style="text-align: center">
                <small> <b> "El saldo del Portafolio Consolidado no considera los préstamos de las Cajas de Ahorro "</b></small>
            </div>
        </div>

</div><br>
<div *ngIf="currentEmployee" style="text-align: center; color: #252440;" class="row mt-4">
    <small>"Los únicos recursos que puedes tener acceso durante ciertos periodos del año, es la <b>Caja de ahorro</b> permanente.
        El <b>Fondo corto</b> se liquida anualmente y el <b>Fondo largo</b> una vez concluyas tu relación laboral con la Organización. 
        Para mayor referencia consulta los reglamentos respectivos."</small>
</div><br>
<div class="row  mb-1 justify-content-end mx-3">
    <button mat-fab color="primary" data-toggle="tooltip" data-placement="bottom" title="Actualizar" (click)="reload()">
    <i class="material-icons">refresh</i>
  </button>
</div>
<ng-template #nullData>

    <div class="row mt-4 mb-4">
      <div class="col-md-12 text-center noActions">
        <h4 class="mt-1"> No existen datos en los acumulados </h4>
        <mat-icon aria-hidden="true">check</mat-icon>
            <h4  *ngIf="currentEmployee && currentEmployee.workInformation.laidOff"> No Hay Datos Actuales </h4>
            <h5 > del colaborador en este momento. </h5>

      </div>
    </div>
  </ng-template>



